import { connect } from 'react-redux';
import { TRootState } from '../../store';

import {
    hasAccessToAllVehicles,
    hasAccessToCards,
    hasAccessToEmployees,
    hasAccessToTanks,
    hasAccessToVehicles,
} from '../../state/user';
import {
    getVehiclesFilter,
    setVehiclesFilter,
} from '../../state/app/registers/vehicles';
import {
    getEmployeesFilter,
    setEmployeesFilter,
} from '../../state/app/registers/employees';
import {
    getRfidCardsFilter,
    setRfidCardsFilter,
} from '../../state/app/registers/rfidCards';
import {
    getFuelTanksFilter,
    setFuelTanksFilter,
} from '../../state/app/registers/tanks';

const mapStateToProps = (state: TRootState) => ({
    hasAccessToCards: hasAccessToCards(state),
    hasAccessToVehicles: hasAccessToVehicles(state),
    hasAccessToEmployees: hasAccessToEmployees(state),
    hasAccessToTanks: hasAccessToTanks(state),
    hasAccessToAllVehicles: hasAccessToAllVehicles(state),
    vehiclesFilter: getVehiclesFilter(state),
    employeesFilter: getEmployeesFilter(state),
    rfidCardsFilter: getRfidCardsFilter(state),
    fuelTanksFilter: getFuelTanksFilter(state),
});

const mapDispatchToProps = {
    setVehiclesFilter,
    setEmployeesFilter,
    setRfidCardsFilter,
    setFuelTanksFilter,
};

type TStateProps = ReturnType<typeof mapStateToProps>;
type TDispatchProps = typeof mapDispatchToProps;

export type TConnectableProps = TStateProps & TDispatchProps;

export const Connectable = connect(mapStateToProps, mapDispatchToProps);
